export const domain = process.env.NEXT_PUBLIC_DOMAIN;
export const fingerprintApiKey = process.env.NEXT_PUBLIC_FINGERPRINT_KEY;
export const isProd = process.env.NODE_ENV === 'production';

export const COUNT_DOWN_TIME__REQUEST_SIGNIN = 180;
export const COUNT_DOWN_TIME__REQUEST_EDIT_BANK = 89;
export const COUNT_DOWN_TIME__REQUEST_RESET_PASSCODE = 180;

export const COOKIE_NAME__ACCESS_TOKEN = 'token';
export const COOKIE_NAME__REFRESH_TOKEN = 'refresh_token';
export const COOKIE_NAME__X_CLIENT_ID = 'X-Client-Id';
export const COOKIE_NAME__X_DEVICE_ID = 'X-Device-Id';
export const COOKIE_NAME__X_PHONE = 'X-Phone';
export const COOKIE_NAME__EXPIRES_MAX_AGE__3M = 60;
export const COOKIE_NAME__EXPIRES_MAX_AGE__6M = 120;

export const LOCAL_STORAGE_KEY__SENT_ACTIVATE_CODE_PAYLOAD = 'sent_a_v_p';
export const LOCAL_STORAGE_KEY__FINGERPRINT = 'fp_pro';
export const LOCAL_STORAGE_KEY__SUGGESTED_CREATE_PASSCODE = 'suggested_c_p';

export const PAGE = {
  PARTNER: 'partner',
  ONWHEEL: 'onwheel',
  AHAMOVE: 'ahamove',
};

export enum LoginType {
  Partner = 'partner',
  OnWheel = 'saas',
  Web = 'web',
}

export enum AuthTab {
  SignIn = '/sign-in',
  SignUp = '/sign-up',
  Logout = '/logout',
  NewPasscode = '/new-passcode',
}

export const AUTH_TABS = [AuthTab?.SignIn, AuthTab?.SignUp];

export enum AuthStep {
  Home = 'home',
  Username = 'username',
  PhoneNumber = 'phone-number',
  OTP = 'otp',
  PassCode = 'passcode',
  NewPasscode = 'new-passcode',
  CreatePasscode = 'create-passcode',
}

export enum AuthStatus {
  Loading = 'loading',
  Unauthenticated = 'unauthenticated',
  Authenticated = 'authenticated',
}

export enum OTPMethod {
  SMS = 'SMS',
  ZNS = 'ZNS',
}

export const PUBLIC_PATHS = ['/sign-in', '/sign-up', '/new-passcode'];

export const REQUIRE_AUTH_EVENT = 'REQUIRE_AUTH';
